import { ArrowRight, Star, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function RelocationReimagined() {
  return <section data-section-id="240220" id="relocation-reimagined" className="bg-background text-foreground relative overflow-hidden py-20 lg:py-32 min-h-[90vh] flex items-center">
      {}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-[800px] h-[800px] bg-primary/5 rounded-lg blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 translate-y-1/3 -translate-x-1/3 w-[600px] h-[600px] bg-primary/5 rounded-lg blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-0">
          
          {}
          <div className="w-full lg:w-[60%] relative z-20 flex flex-col items-start">
            <Badge variant="outline" className="mb-6 border-primary/30 bg-primary/5 text-primary backdrop-blur-sm px-4 py-1.5 rounded-md">
              <Zap className="w-4 h-4 mr-2 text-primary" />
              Professional Moving Logistics
            </Badge>
            
            <h1 className="font-serif text-5xl sm:text-7xl lg:text-[5.5rem] xl:text-8xl font-bold tracking-tighter uppercase leading-[0.9] text-foreground">
              Relocation <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-red-600">
                Reimagined
              </span>
            </h1>
            
            <p className="mt-8 text-lg sm:text-xl text-muted-foreground max-w-lg font-default leading-relaxed">
              Experience the future of moving with <strong className="text-foreground font-medium">Kinetic Precision</strong>. We handle your residential and commercial transitions with expert care and <strong className="text-foreground font-medium">Modern Tracking</strong>.
            </p>
            
            <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
              <Button asChild size="lg" className="rounded-md px-8 h-14 text-lg group transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-primary/25 w-full sm:w-auto bg-primary text-primary-foreground">
                <Link to="/GetQuotePage">
                  Start My Move
                  <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-md px-8 h-14 text-lg border-border hover:bg-muted w-full sm:w-auto">
                <Link to="/ResourcesPage">
                  View Services
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="w-full lg:w-[40%] relative z-10 lg:-ml-16 mt-16 lg:mt-0">
            {}
            <div className="relative aspect-[4/5] w-full max-w-md mx-auto lg:max-w-none rounded-md overflow-hidden border border-border bg-card/30 backdrop-blur-sm shadow-xl group">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 z-10 pointer-events-none" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/shift_moving_truck_motion.png" alt="Shift professional moving truck in high speed motion" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent z-10" />
            </div>

            {}
            <div className="absolute top-12 -left-4 sm:-left-12 z-30 backdrop-blur-md bg-background/90 border border-primary/20 rounded-md p-4 shadow-lg flex items-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
              <div className="bg-primary/10 p-2.5 rounded-md border border-primary/20">
                <Star className="w-6 h-6 text-primary fill-primary" />
              </div>
              <div>
                <p className="font-serif font-bold text-xl leading-none text-foreground">5.0/5</p>
                <p className="text-xs text-muted-foreground uppercase tracking-wider mt-1 font-medium">Reliability</p>
              </div>
            </div>
            
            {}
            <div className="absolute bottom-12 -right-6 z-30 grid grid-cols-3 gap-2 opacity-30">
              {[...Array(9)].map((_, i) => <div key={i} data-index={i} className="w-1.5 h-1.5 rounded-md bg-primary" />)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}